import * as TSE from 'ts-events';

// import html
import template from './icon-component.hogan.html';
// js
import { HtmlComponent } from './../../html-component';

export class IconComponent extends HtmlComponent {
    public clickEvent: any;

    constructor(parameters: {}) {
        super(template, parameters);
        this.clickEvent = new TSE.SyncEvent();
        this.jqueryElement.click(e => {
            this.clickEvent.post(e);
        });
    }

    public enable() {
        this.jqueryElement.addClass('icon-component-enabled');
        this.jqueryElement.removeClass('icon-component-disabled');
    }

    public disable() {
        this.jqueryElement.removeClass('icon-component-enabled');
        this.jqueryElement.addClass('icon-component-disabled');
    }
}
